import { mapKeys, camelCase } from 'lodash';

/**
 * @param {Record<string, any>} data
 * @returns {Record<string, any>}
 */
export const mapKeysToCamelCase = (data) => mapKeys(data, (value, key) => camelCase(key));
